import React from 'react';
import CustomNextArrow from '../../library/baaShared/CustomArrow/CustomNextArrow';
import CustomPrevArrow from '../../library/baaShared/CustomArrow/CustomPrevArrow';
import nextImage from "../../assets/black/icons-icon-arrow-left.png";
import Slider from 'react-slick';
import ExperienceCard from './ExperienceCard';
import './VisitExperiences.scss';
import ComponentTitleSection from '../../library/baaShared/ComponentTitleSection';
import { withRouter } from 'react-router';
import dictionary from "i18next";

class VisitExperiences extends React.Component {
  render() {
    let setting = {
      dots: false,
      infinite: true,
      className: "center",
      centerPadding: "220px",
      centerMode: true,
      slidesToShow: 1,
      speed: 500,
      nextArrow: <CustomNextArrow img={nextImage} />,
      prevArrow: <CustomPrevArrow img={nextImage} />,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3,
            centerPadding: "130px"
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
            centerPadding: "80px",
            initialSlide: 0,
            arrows: false,
            speed: 500,
            infinite: true,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
            centerPadding: "40px",
            initialSlide: 0,
            arrows: false,
            speed: 500,
            infinite: true,
          }
        }
      ]
    }

    return (
      <div className="visit-experience-component">
        <ComponentTitleSection subtitle={this.props.fields.Title.value} />
        <Slider {...setting}>
          {this.props.fields && this.props.fields["Experience List"] && this.props.fields["Experience List"].length > 0 ?
            this.props.fields["Experience List"].map(item => {
              let image = item.fields && item.fields['Home Visit Image'] && item.fields['Home Visit Image'].value && item.fields['Home Visit Image'].value.src ? item.fields['Home Visit Image'].value.src : '';
              let title = item.fields && item.fields['Home Visit Title'] && item.fields['Home Visit Title'].value ? item.fields['Home Visit Title'].value : ""
              let subTitle = item.fields && item.fields['Home Visit Short Description'] && item.fields['Home Visit Short Description'].value ? item.fields['Home Visit Short Description'].value : ""
              let ctaText = dictionary.t("ContactForm-Discovermore", "DISCOVER MORE")

              let ctaLink = this.props.fields && this.props.fields["CTA link"] && this.props.fields["CTA link"].value && this.props.fields["CTA link"].value.href ? this.props.fields["CTA link"].value.href : ''
              let vistTitle = item.fields && item.fields["Visit Title"] && item.fields["Visit Title"].value ? item.fields["Visit Title"].value : ""
              return (
                <ExperienceCard image={image} title={title} subTitle={subTitle} ctaText={ctaText} ctaLink={ctaLink} history={this.props.history} vistTitle={vistTitle} />
              )
            })
            : ""}
        </Slider>
      </div>
    )
  }
}

export default withRouter(VisitExperiences);
